import { obtenerPrimero, parsearJsonSeguro } from './configuracionInicial.constants';

export const estadoRespuestaDe = respuesta => obtenerPrimero(respuesta,
  ['EstadoRespuesta', 'estadoRespuesta', 'Estado', 'estado'], 'SIN_RESPONDER');
export const respuestaContenidoDe = respuesta => parsearJsonSeguro(obtenerPrimero(respuesta,
  ['ContenidoRespuestaJson', 'contenidoRespuestaJson', 'ValorRespuestaJson', 'valorRespuestaJson'], null));

const etiqueta = opcion => opcion?.Etiqueta || opcion?.label;
const codigo = opcion => opcion?.Codigo || opcion?.id;
const textoSeguro = (valor, clave = '') => {
  if (valor == null || valor === '') return '';
  if (/PASSWORD|CONTRASE|TOKEN|SECRET/i.test(clave)) return '••••••';
  if (/NUMERO_CUENTA|accountNumber/i.test(clave)) return `•••• ${String(valor).slice(-4)}`;
  if (typeof valor === 'boolean') return valor ? 'Sí' : 'No';
  return typeof valor === 'object' ? '' : String(valor);
};

// Only expose fields declared for the user; persistence metadata stays out of the review.
export const describirRespuesta = (elemento, contenido) => {
  if (contenido == null) return [];
  if (typeof contenido !== 'object') return [{ valor: textoSeguro(contenido) }];
  const opciones = elemento?.Opciones || [];
  const entradas = [];
  (contenido.selectedOptionIds || []).forEach(id => {
    const opcion = opciones.find(item => codigo(item) === id);
    const detalles = contenido.optionDetails?.[id] || {};
    entradas.push({ valor: etiqueta(opcion) || 'Selección anterior (revisar)' });
    if (detalles.initialRate != null && detalles.initialRate !== '') {
      entradas.push({ etiqueta: 'Tasa inicial', valor: textoSeguro(detalles.initialRate) });
    }
    (elemento.CamposDetalle || []).forEach(campo => {
      if (campo.ControlEntrada === 'HIDDEN') return;
      const valor = textoSeguro(detalles[codigo(campo)], codigo(campo));
      if (valor) entradas.push({ etiqueta: etiqueta(campo), valor });
    });
  });
  const fields = contenido.fields || {};
  opciones.forEach(campo => {
    const id = codigo(campo);
    if (campo.ControlEntrada === 'HIDDEN' || id === 'BAN-02.INACTIVAR') return;
    const precio = /^VEN-07\.PRECIO([2-5])_LABEL$/.exec(id);
    if (precio && Number(precio[1]) > Number(fields['VEN-07.CANTIDAD_PRECIOS'])) return;
    let valor = fields[id];
    if (id === 'EMP-05.NUMERO') return;
    if (id === 'EMP-05.CALLE') valor = [valor, fields['EMP-05.NUMERO']].filter(Boolean).join(', ');
    if (id === 'EMP-05.PAIS' && /^(DO|RD)$/i.test(String(valor))) valor = 'República Dominicana';
    const permitida = (campo.ValoresPermitidos || []).find(item => String(item.Valor) === String(valor));
    valor = permitida ? permitida.Etiqueta : valor;
    // Geographic IDs require catalog lookup in the editor; never present an ID as a place name.
    if (/^EMP-05\.(PROVINCIA|MUNICIPIO|BARRIO|SUBBARRIO)$/.test(id) && /^\d+$/.test(String(valor))) {
      valor = 'Seleccionado (ver en Editar)';
    }
    const texto = textoSeguro(valor, id);
    if (texto) entradas.push({ etiqueta: id === 'EMP-05.CALLE' ? 'Dirección' : etiqueta(campo), valor: texto });
  });
  if (fields['BAN-02.INACTIVAR'] === true) entradas.push({ valor: 'Retirar esta cuenta al finalizar' });
  if (contenido.note) entradas.push({ etiqueta: 'Detalle', valor: textoSeguro(contenido.note) });
  return entradas;
};

export const estadoRevision = (respuesta, diferencia, omitida = false) => {
  const estado = estadoRespuestaDe(respuesta);
  if (omitida || estado === 'OMITIDA') return { texto: 'Omitida', clase: 'neutral' };
  if (estado === 'PARA_DESPUES') return { texto: 'Para después', clase: 'pending' };
  if (estado !== 'RESPONDIDA') return { texto: 'Sin confirmar', clase: 'pending' };
  const validacion = obtenerPrimero(diferencia, ['Estado', 'estado'], '');
  if (['BLOQUEANTE', 'BLOQUEADA', 'ERROR'].includes(validacion)) return { texto: 'Requiere revisión', clase: 'pending' };
  if (obtenerPrimero(diferencia, ['EsAplicable', 'esAplicable'], true) === false) return { texto: 'Solo informativa', clase: 'neutral' };
  const operacion = obtenerPrimero(diferencia, ['Operacion', 'operacion'], '');
  const textos = { SIN_CAMBIO: 'Sin cambios', CREAR: 'Por crear', ACTUALIZAR: 'Por actualizar', ACTIVAR: 'Por activar', DESACTIVAR: 'Por inactivar' };
  return { texto: textos[operacion] || 'Guardada', clase: operacion && operacion !== 'SIN_CAMBIO' ? 'change' : 'neutral' };
};
